// Date formatting utility
export const formatDate = (dateString) => {
	if (!dateString) return "N/A";

	try {
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return "Invalid Date";

		return date.toLocaleDateString("ko-KR", {
			year: "numeric",
			month: "long",
			day: "numeric",
		});
	} catch (error) {
		return "Invalid Date";
	}
};

// Currency formatting utility
export const formatCurrency = (amount) => {
	if (amount === null || amount === undefined) return "₩0";

	return new Intl.NumberFormat("ko-KR", {
		style: "currency",
		currency: "KRW",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(amount);
};

// Duration formatting utility
export const formatDuration = (seconds) => {
	if (!seconds) return "0:00";

	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;

	if (hours > 0) {
		return `${hours}:${minutes
			.toString()
			.padStart(2, "0")}:${remainingSeconds
			.toString()
			.padStart(2, "0")}`;
	} else {
		return `${minutes}:${remainingSeconds
			.toString()
			.padStart(2, "0")}`;
	}
};
